<template>
  <v-btn flat icon color="red" class="report_problem" @mouseover="alertMessage">
    <v-list-tile-content>
      <p class="report_problem__text" v-show="showAlertMessage">プレイリストに重複する楽曲が存在しています</p>
      <v-icon>report_problem</v-icon>
    </v-list-tile-content>
  </v-btn>
</template>
<script>
export default {
  name: 'DuplicationAlertButton',
  data () {
    return {
      showAlertMessage: false
    }
  },
  methods: {
    alertMessage () {
      this.showAlertMessage = true
      let that = this
      setTimeout(() => {
        that.showAlertMessage = false
      }, 3000)
    }
  }
}
</script>
<style lang="scss" scoped>
  .report_problem__text {
    background: red;
    color: #fff;
    display: none;
    z-index: 10;
    position: absolute;
    font-size: small;
    top: -2rem;
    left: -10rem;
    padding: 0.5rem;
  }
  .report_problem:hover /deep/ .report_problem__text {
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/components/Modules/DuplicationAlertButton.vue